export default __webpack_public_path__ + "static/media/avatar.eae52eaa.svg";